var BellMessageCardType = /* @__PURE__ */ ((BellMessageCardType2) => {
  BellMessageCardType2[BellMessageCardType2["error"] = 0] = "error";
  BellMessageCardType2[BellMessageCardType2["warning"] = 1] = "warning";
  BellMessageCardType2[BellMessageCardType2["inprogress"] = 2] = "inprogress";
  BellMessageCardType2[BellMessageCardType2["success"] = 3] = "success";
  BellMessageCardType2[BellMessageCardType2["info"] = 4] = "info";
  BellMessageCardType2[BellMessageCardType2["upsell"] = 5] = "upsell";
  return BellMessageCardType2;
})(BellMessageCardType || {});
export {
  BellMessageCardType
};
//# sourceMappingURL=BellMessageCard.types.js.map
